function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Text summary component
 * 
 */

import * as React from 'react';
import { COUNTRIES } from '../../../data/Data';
import './Text.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Text extends React.Component {
  render() {
    let {
      label,
      name,
      value
    } = this.props;
    let classes = `Text ${name}`;
    if ('placeOfBirth' === this.props.name) {
      for (let i = 0; i < COUNTRIES.length; i++) {
        if (COUNTRIES[i].value === value) {
          value = COUNTRIES[i].title;
        }
      }
    }
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsx("div", {
        className: "label",
        children: label
      }), /*#__PURE__*/_jsx("div", {
        className: "value",
        children: value
      })]
    });
  }
}
_defineProperty(Text, "defaultProps", {
  label: 'Name',
  name: 'fullName',
  value: 'Harvey Milk'
});
export default Text;